import { useIsTreatmentVariantByUser } from "../../utils";
import { PAWS_BRAINTREE_CC_EXPERIMENT_KEY } from "../../experimentKeys";

export { PAWS_BRAINTREE_CC_EXPERIMENT_KEY };

export const usePawsBraintreeCC = () =>
  useIsTreatmentVariantByUser(PAWS_BRAINTREE_CC_EXPERIMENT_KEY);
